<template>
    <div v-if="lenderName" class="row">
        <div class="offer-content lender-name" :class="[fontSize]">
            <div class="column-container col-lg-12 order-lg-1 d-lg-flex">
                <div class="row">
                    <div class="col-12 d-flex">
                        <p class="mb-0">
                            <span class="main-text small-main-text lender-name">
                                {{ lenderName }}
                            </span>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import inRange from 'lodash/inRange'

export default {
    props: ['lenderName'],
    computed: {
        fontSize: function () {
            let lenderLength = this.lenderName.length
            let size

            switch (true) {
                case this.windowWidth >= 1200 && lenderLength > 132:
                case inRange(this.windowWidth, 992, 1200) && lenderLength > 112:
                case inRange(this.windowWidth, 768, 992) && lenderLength > 100:
                case inRange(this.windowWidth, 576, 768) && lenderLength > 73:
                case this.windowWidth <= 576 && lenderLength > 82:
                    size = 'mb-r14'
                    break
                default:
                    size = ''
            }

            return size
        },
    },
}
</script>
